import React from 'react';
import Loading from 'components/Loading';
import FlexCentered from 'components/Common/FlexCentered';
import { V3SelectedAppContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';

import MappedEntityViewScreen from 'screens/V3/Workspace/screens/MappedEntityViewScreen';
import useMappedEntityAppParams from '../useMappedEntityAppParams';

const MappedEntityApp = ({
  navItem,
  app,
}: {
  navItem: V3.Navigation.MappedEntityView;
  app: V3.ProductApp;
}) => {
  return (
    <V3SelectedAppContext.Provider value={{ selectedProductApp: app }}>
      <MappedEntityViewScreen selectedItem={navItem} />
    </V3SelectedAppContext.Provider>
  );
};

const Gate = () => {
  const { navItem, app } = useMappedEntityAppParams();

  if (!navItem || !app) {
    return (
      <FlexCentered>
        <Loading />
      </FlexCentered>
    );
  }

  return <MappedEntityApp app={app} navItem={navItem} />;
};

export default Gate;
